module.exports = __webpack_public_path__ + "static/img/track_cn_blue.d51b24a3.png";